function ModernPopupBody({ onClose, children }) {
  return (
    <div className="mpb-container">
      {/* This is the "Slot" where your custom icon/title/button will go */}
      <div className="body-content-modern-popup">
        {children}
      </div>
    </div>
  );
}

export default ModernPopupBody;
